import { createContext } from "react";
export var initialContext = {
    stories: []
};
var StoriesContext = createContext(initialContext);
export default StoriesContext;
